// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.game-list {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

@media (min-width: 768px) {
  .game-list {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    align-items: start;
  }
}

@media (min-width: 1024px) {
  .game-list {
    grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
  }
}

@media (max-width: 375px) {
  .game-list {
    gap: var(--space-2);
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/games/GameList.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;IACb,gDAAgD;IAChD,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,4DAA4D;EAC9D;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".game-list {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-3);\n}\n\n@media (min-width: 768px) {\n  .game-list {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    align-items: start;\n  }\n}\n\n@media (min-width: 1024px) {\n  .game-list {\n    grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));\n  }\n}\n\n@media (max-width: 375px) {\n  .game-list {\n    gap: var(--space-2);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
